import styled from '@emotion/styled';

const CheckboxLabel = styled.label`
  display: flex !important;
  align-items: flex-start;
  gap: 10px;
  box-sizing: border-box;
  width: 100%;
  max-width: 420px;
  margin: 12px auto 16px;
  padding: 0 4px;
  text-align: left;
  font-size: 14px;
  line-height: 1.35;
  color: inherit;
  cursor: pointer;
  user-select: none;

  /* Parent forms often force all inputs to width: 100% on mobile */
  input[type='checkbox'] {
    margin-top: 3px;
    flex: 0 0 auto;
    width: auto !important;
    max-width: none !important;
    display: inline-block !important;
    cursor: pointer;
  }

  span {
    flex: 1 1 auto;
    min-width: 0;
    white-space: normal;
    overflow-wrap: break-word;
  }
`;

/**
 * Opt-in control shown below identification/phone fields.
 * Ask before persisting credentials to sessionStorage.
 */
const RememberCredentialsCheckbox = ({
  checked = false,
  onChange,
  id = 'remember-credentials',
  className,
}) => (
  <CheckboxLabel htmlFor={id} className={className}>
    <input
      id={id}
      type="checkbox"
      checked={Boolean(checked)}
      onChange={(e) => onChange?.(e.target.checked)}
    />
    <span>¿Deseas guardar tu información para acceder más rápido?</span>
  </CheckboxLabel>
);

export default RememberCredentialsCheckbox;
